export default {
  init() {
    // JavaScript to be fired on the home page
    var checkboxes = document.querySelectorAll('.frm_checkbox');

    checkboxes.forEach(checkbox => {
      var input = checkbox.querySelector('input[type="checkbox"]');
      checkbox.prepend(input);
      checkbox.classList.add('frm_checkbox_custom');
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/newsletter.js